export default __webpack_public_path__ + "06164112e9c2a816ef96ed900c71826e.woff2";